import { educationCheckActionTypes } from '@/components/modals/mistakeIntervention/Constants';

import type {
	MistakeInterventionActions,
	MistakeInterventionState,
} from '@/components/modals/mistakeIntervention/types';

const initialState: MistakeInterventionState = {
	mistakeInterventionId: null,
	openEducationCheck: false,
	openReviewTopics: false,
};

export default function educationCheckReducer(
	state = initialState,
	action: MistakeInterventionActions,
): MistakeInterventionState {
	switch (action.type) {
		case educationCheckActionTypes.TOGGLE_EDUCATION_CHECK_MODAL:
			return {
				...state,
				openEducationCheck: action.payload.openEducationCheck,
			};
		case educationCheckActionTypes.TOGGLE_REVIEW_TOPICS_MODAL:
			return {
				...state,
				openReviewTopics: action.payload.openReviewTopics,
			};
		case educationCheckActionTypes.SET_MISTAKE_INTERVENTION_ID:
			return {
				...state,
				mistakeInterventionId: action.payload.mistakeInterventionId,
			};
		default:
			return state;
	}
}
